import { Alert, Metric, SubscriptionInfo, Thing, ThingDefinition, ThingTestSession, WorkOrder, WorkSession } from "../../model";

export abstract class AbstractThingContextService {
    public abstract getCurrentThing(): Thing;
    public abstract getCurrentThingDefinition(): ThingDefinition;
    public abstract getCurrentThingTestSession(): ThingTestSession;
    public abstract getCurrentWorkSession(): WorkSession;
    public abstract getMetrics(): Promise<Metric[]>;
    public abstract getMetricByName(name: string): Promise<Metric>;
    public abstract getCurrentAlert(): Alert;
    public abstract getParentThing(): Thing;
    public abstract getRootThing(): Thing;
    public abstract getCurrentWorkOrder(): WorkOrder;

    getSubscription(): SubscriptionInfo {
        const thing = this.getCurrentThing();
        if (!thing) {
            return null;
        }
        return thing.subscriptionInfo;
    }
}